export const getCdnUrl = (path: string): string => {
  const cdnHost = process.env.NEXT_PUBLIC_CDN_HOST;
  const environment = process.env.NEXT_PUBLIC_ENVIRONMENT;
  const version = process.env.NEXT_PUBLIC_VERSION || 'latest';

  // Remove leading slash if present
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;

  return `${cdnHost}/${environment}/${version}/${cleanPath}`;
};

// Helper function to determine if we should use CDN
export const shouldUseCdn = (): boolean => {
  const environment = process.env.NEXT_PUBLIC_ENVIRONMENT;
  // return ['beta', 'production'].includes(environment ?? '');
  return true;
};

// Helper for assets served from the diversity CloudFront distribution
// (NEXT_PUBLIC_DIVERSITY_CDN). Uses a stable, unversioned path. Falls back to
// an origin-relative path when the CDN host isn't configured for the env.
export const getDiversityCdnUrl = (path: string): string => {
  // If URL already has a protocol/host, return as is
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  const diversityCdn = process.env.NEXT_PUBLIC_DIVERSITY_CDN;
  const assetPath = path.startsWith('/') ? path.slice(1) : path;

  return diversityCdn ? `${diversityCdn}/${assetPath}` : `/${assetPath}`;
};

// Helper for assets served from the showcase CloudFront distribution
// (NEXT_PUBLIC_SHOWCASE_CDN). Uses a stable, unversioned path. Falls back to
// an origin-relative path when the CDN host isn't configured for the env.
export const getShowcaseCdnUrl = (path: string): string => {
  // If URL already has a protocol/host, return as is
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  const showcaseCdn = process.env.NEXT_PUBLIC_SHOWCASE_CDN;
  const assetPath = path.startsWith('/') ? path.slice(1) : path;

  return showcaseCdn ? `${showcaseCdn}/${assetPath}` : `/${assetPath}`;
};

// Helper function specifically for public folder assets
export const getPublicAssetUrl = (path: string): string => {
  // If URL already has a protocol/host, return as is
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  // Handle both with and without leading slash
  const assetPath = path.startsWith('/') ? path.slice(1) : path;
  return shouldUseCdn() ? getCdnUrl(assetPath) : `/${assetPath}`;
};
